const mutations = {
  getCart(state) {
    window.cartInstance.getters.cartInstance.getCart((responseData) => {
      if (responseData) {
        state.cart = { ...state.cart, ...responseData };
      }
    }, state.b2bUser && state.b2b?.role);
  },
  setCartLoaded(state, input) {
    state.cartLoaded = input;
  }
};

export default mutations;
